module.exports = __webpack_public_path__ + "static/me_pizza-90715556fa2756d0a6e605756f9ec779.jpg";